export function documentStatusVariant(status: string) {
  if (["signed", "accepted"].includes(status)) return "success" as const;
  if (["current", "sent"].includes(status)) return "default" as const;
  if (["declined", "expired"].includes(status)) return "warning" as const;
  return "secondary" as const;
}
export function documentMoney(minor: number) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(minor / 100);
}
export function documentDate(date: string | null) {
  return date
    ? new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC",
      }).format(new Date(`${date}T00:00:00Z`))
    : "—";
}
